import { openDB } from 'idb';

const DB_NAME = 'APESTER';
const DB_VERSION = 1;
const STORE_NAME = 'STRIP';

// Check storage consent from URL param (passed by web-sdk)
// Default: allowed if param is absent (feature not enabled), blocked if param is 'false'
let storageAllowed = true;
try {
  const params = new URLSearchParams(window.location.search);
  const consentParam = params.get('storageConsent');
  if (consentParam !== null) {
    storageAllowed = consentParam === 'true';
  }
} catch { /* ignore */ }

// Listen for real-time consent updates from web-sdk
try {
  window.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'apester_storage_consent') {
      storageAllowed = event.data.granted;
      // If consent just granted and IndexedDB not yet opened, open it now
      if (storageAllowed && !dbOpened) {
        try {
          initDB();
          // Flush in-memory seen interactions to IndexedDB
          (async () => {
            try {
              const db = await dbPromise;
              const tx = db.transaction(STORE_NAME, 'readwrite');
              const store = tx.objectStore(STORE_NAME);
              for (const id of Object.keys(inMemorySeenInteractions)) {
                store.put(true, id);
              }
              await tx.done;
            } catch { /* ignore */ }
          })();
        } catch { /* ignore */ }
      }
    }
  });
} catch { /* ignore */ }

// In-memory fallback for when consent is not granted
const inMemorySeenInteractions = {};

function initDB() {
  dbPromise = openDB(DB_NAME, DB_VERSION, {
    upgrade: db => {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    },
  });
  dbOpened = true;
}

let dbPromise = Promise.resolve();
let dbOpened = false;
if (storageAllowed) {
  try {
    initDB();
  } catch {
    /* indexedDB open failed — silent, non-critical */
  }
}

class IndexedDBHelper {
  static async getAllSeenInteractions() {
    if (!storageAllowed) {
      return { ...inMemorySeenInteractions };
    }
    try {
      const store = (await dbPromise).transaction(STORE_NAME).objectStore(STORE_NAME);
      return await store.getAllKeys().then(allInteractions => {
        // The object is formated like this {1: interactionId, 2: interactionId}
        // and we want it to be {interactionId: 1, interactionId: 2}
        return allInteractions.reduce((acc, interactionId) => {
          acc[interactionId] = true;
          return acc;
        }, {});
      });
    } catch {}
  }

  static async setInteractionSeen(interactionId) {
    if (!storageAllowed) {
      inMemorySeenInteractions[interactionId] = true;
      return;
    }
    try {
      const tx = (await dbPromise).transaction(STORE_NAME, 'readwrite');
      const store = tx.objectStore(STORE_NAME);
      const isInteractionSeen = await store.get(interactionId);
      if (!isInteractionSeen) {
        await store.put(true, interactionId);
      }
      return tx.done;
    } catch {}
  }
}

export default IndexedDBHelper;
